<template>
    <div class="ReportSearch">
        <div class="search-content clear">
            <!--搜索导航-->
            <div class="search-request clear" v-if="getCourseByKeyApi.key">
                <div class="float-left border">关键词：{{getCourseByKeyApi.key}} <i class="icon-del" @click="delkey"></i></div>
                <p class="float-left">共找到<span>{{rowCount}}</span>门<span>“{{getCourseByKeyApi.key}}”</span>相关报告</p>
            </div>
            <!--搜索列表-->
            <div class="search-class">
                <div class="big-class item">
                    <p class="name">发布时间：</p>
                    <div class="msg">
                        <span v-for="(item,index) in publishTime" :key="index" :class="{active: getCourseByKeyApi.timetype == item.code}" @click="tabTime(item.code)">{{item.name}}</span>
                    </div>
                </div>
                <div class="small-class item">
                    <p class="name">活动城市：</p>
                    <div class="msg">
                        <div><span :class="{active: getCourseByKeyApi.city == ''}" @click="tabCity('')">全部</span></div>
                        <span v-for="(items,indexs) in cityList" :key="indexs" :class="{active: getCourseByKeyApi.city == items.name}" @click="tabCity(items.name)">{{items.name}}</span>
                    </div>
                </div>
                <div class="type item">
                    <p class="name">活动类型：</p>
                    <div class="msg">
                        <span v-for="(items,indexs) in hdtype" :key="indexs" :class="{active: getCourseByKeyApi.feetype == items.code}" @click="tabFeetype(items.code)">{{items.name}}</span>
                    </div>
                </div>
                <div class="year item">
                    <p class="name">活动状态：</p>
                    <div class="msg">
                        <span v-for="(items,indexs) in hdStatus" :key="indexs" :class="{active: getCourseByKeyApi.status == items.code}" @click="tabStatus(items.code)">{{items.name}}</span>
                    </div>
                </div>
            </div>

            <div class="search-main">
                <div class="null" v-if="eventList.length === 0">
                    <img src="~common/images/search/search-null.png" alt="searchnull">
                    当前暂无活动
                </div>
                <div class="search-list clear" v-if="eventList.length > 0">
                    <div class="event_box" v-for="(item,index) in eventList" :key="index"><IndexList  :dataList="item"></IndexList></div>
                </div>
            </div>
            <!-- 搜索主体 -->
            <el-pagination background layout="prev, pager, next" :page-size="getCourseByKeyApi.pageSize" :current-page="getCourseByKeyApi.page" :total="rowCount" v-if="eventList.length > 0" @current-change="handleCurrentChange"></el-pagination>
            <!-- 分页 -->
        </div>
    </div>
</template>

<script>
    import $ from 'jquery'
    import {mapActions, mapGetters} from 'vuex'
    import hdCity from '@/views/hdPc/components/hdCity.json'
    import IndexList from '@/views/hdPc/components/indexList'
    import {getSearchList} from 'api/hdApi'
    export default {
        name: "HdSearch",
        data() {
            return {
                cityList: [], // 城市列表
                publishTime:[{name:'全部',code:''},{name:'一天以内',code:'1'},{name:'三天以内',code:'2'},{name:'一周以内',code:'3'},{name:'一个月以内',code:'4'}], //发布时间
                hdtype: [{name:"全部", code: ""},{name:"免费", code: "1"},{name:"收费", code: "2"}], // 活动类型
                hdStatus: [{name:"全部", code: ""},{name:"未开始", code: "9"},{name:"进行中", code: "10"},{name:"已结束", code: "30"}], // 活动状态
                eventList: [], // 课程列表
                keyType: 0,    // 课程类别关键词选中下标
                getCourseByKeyApi: {
                    key: this.$route.query.data ? decodeURI(this.$route.query.data) : '',   // 搜索关键词样式
                    feetype: this.$route.query.feetype ? this.$route.query.feetype : '', // 报告类型 1免费 2收费
                    status: this.$route.query.status ? this.$route.query.status : '', // 活动状态
                    timetype: this.$route.query.timetype ? this.$route.query.timetype : '', // 发布时间
                    city: this.$route.query.city ? this.$route.query.city : '', // 活动城市
                    page: 1,   // 页码
                    pageSize: 32,   // 每页记录数
                },
                rowCount: 0,
                title: this.$route.query.title,
            }
        },
        created() {
            // if(this.domainInfo.isMobile){
            //     let routerQuery = {
            //         catecode: this.$route.query.catecode,
            //         feetype: this.$route.query.feetype,
            //         reportyear: this.$route.query.reportyear
            //     }
            //     if (this.$route.query.isMobile && this.$route.query.isMobile == 1) {
            //         routerQuery.key = this.$route.query.data ? this.$route.query.data: ''
            //     } else {
            //         routerQuery.key = this.$route.query.data ? encodeURI(this.$route.query.data): ''
            //     }
            //     this.$router.push({
            //         name: 'MReportSearch',
            //         query: routerQuery
            //     })
            // }
        },
        mounted() {
            this.cityList = hdCity
            // 回到定点
            this._clearScrollTop()
            this.getSearchResult(1)
        },
        methods: {
            getSearchResult(page) { // 获取活动列表
                this._clearScrollTop()
                this.getCourseByKeyApi.page = page
                this.setLoading(true)
                getSearchList({
                    data: this.getCourseByKeyApi,
                    success: data => {
                        this.setLoading(false)
                        this.eventList = data.data.content
                        this.rowCount = data.data.pageinfo.rowCount
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            tabTime(code) {
                this.getCourseByKeyApi.timetype = code
                this.getSearchResult(1)
            },
            tabCity(code) {
                this.getCourseByKeyApi.city = code
                this.getSearchResult(1)
            },
            tabFeetype(code) {
                this.getCourseByKeyApi.feetype = code
                this.getSearchResult(1)
            },
            tabStatus(code) {
                this.getCourseByKeyApi.status = code
                this.getSearchResult(1)
            },
            handleCurrentChange(val) { // 页数发生变化时触发
                // 页数发生变化，取得列表
                this.getSearchResult(val)
            },
            delkey() { // 清空选中关键词
                this.$router.push({name: 'HdSearch'})
            },
            _clearScrollTop() { // 初始化滚动条高度
                this.$nextTick(() => {
                    $('html').scrollTop(0)
                })
            },
            ...mapActions([
                'setLoading'
            ])
        },
        filters: {},
        watch: {
            $route: {
                handler (val) { // val 更新的, oldVal 过去的
                    this.getCourseByKeyApi.key = val.query.data;
                    this.getSearchResult(1)
                },
                deep: true
            }
        },
        computed: {
            ...mapGetters(
                ['domainlist', 'domainInfo']
            )
        },
        components: {
            IndexList
        }
    }
</script>

<style lang="scss" type="text/scss" >
    .ReportSearch {
        .standardCourseCard .title {
            font-size: 14px;
        }
        // margin-top: 80px;
        .el-menu {
            margin-bottom: 31px;
            .el-menu-item {
                font-size: 18px;
            }
            .el-menu-item.is-active {
                color: #409EFF !important;
            }
        }
        .null {
            margin-top: 120px;
            margin-bottom: 180px;
            text-align: center;
            color: #CADAEE;
            font-size: 18px;
            img {
                margin: auto;
                margin-bottom: 26px;
                width: 234px;
                height: 121px;
            }
        }
        .icon-del {
            display: inline-block;
            width: 10px;
            height: 10px;
            cursor: pointer;
            background: url('../../../common/images/search/del.png');
            background-size: 10px;
        }
        .search-content {
            margin: auto;
            /*padding-top: 30px;*/
            width: 1180px;
            .search-request {
                margin-bottom: 20px;
                .border {
                    padding: 0 8px;
                    height: 28px;
                    line-height: 28px;
                    font-size: 14px;
                    border: dashed  1px #409EFF;
                }
                p {
                    margin-left: 30px;
                    line-height: 28px;
                    font-size: 14px;
                    span {
                        display: inline-block;
                        padding:  0 5px;
                        color: #409EFF
                    }
                }
            }
            .search-class {
                width: 1200px;
                // margin-top: 20px;
                overflow: hidden;
                background:rgba(255,255,255,1);
                border: solid 1px #eee;
                .item {
                    padding-top: 20px;
                    overflow: hidden;
                    padding-left: 20px;
                    padding-right: 20px;
                    &~.item {
                        border-top: solid 1px #eee;
                    }
                }
                .name {
                    float: left;
                    display: block;
                    width: 83px;
                }
                .msg {
                    float: left;
                    width: calc(100% - 83px);
                }
                span {
                    float: left;
                    display: inline-block;
                    height: 20px;
                    line-height: 20px;
                    margin-bottom: 15px;
                    font-size: 12px;
                    margin-left: 30px;
                    cursor: pointer;

                    &.active {
                        font-size: 12px;
                        padding: 0 7px;
                        color: #fff;
                        background:#409EFF;
                        border-radius:10px;
                    }
                }
            }
            .search-main {
                margin-top: 20px;
                .search-list {
                    margin: 0 -20px 0 0;
                    display: flex;
                    flex-wrap: wrap;
                    /*justify-content: space-between;*/
                    .event_box{
                        width: 285px;
                        margin-right: 19.9px;
                    }
                    .event_box:nth-child(4n){
                        margin-right: 0;
                    }
                    /*.event_box:nth-child(3n+1){*/
                        /*margin-right: 0*/
                    /*}*/
                    .indexList{
                        margin-bottom: 20px;
                    }
                }
                /*.search-list:after{*/
                    /*!*content: '';*!*/
                    /*!*width: 285px;*!*/
                    /*!*border:1px solid transparent;*!*/
                    /*display:block;*/
                    /*content:"";*/
                    /*width: 285px;*/
                    /*height:0px;*/
                /*}*/
            }
            .el-pagination {
                margin: 20px;
                text-align: center
            }
        }
    }
</style>